import { Component, OnInit, EventEmitter, Output, Input, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ConnectionService } from 'src/app/shared-services/connection.service';
import { environment } from 'src/environments/environment';
import { ApplicationBusinessInfo } from '../application.business.info';
import { distinctUntilChanged } from 'rxjs/operators';
import { ApplicationSoleOwnerItem } from '../application.sole.owner.item';
import { AuthService } from 'src/app/auth/auth.service';
import { GoogleAnalyticsService } from 'src/app/analytics/google.analytics.service';
import { ActivatedRoute } from '@angular/router';
declare var $: any;

@Component({
    selector: 'app-sole-owner-information',
    templateUrl: './sole-owner-information.component.html',
    styleUrls: ['./sole-owner-information.component.css', '../application.component.css']
})
export class SoleOwnerInformationComponent implements OnInit {
    @Input() token: any;
    @Input() referralPage: any;
    @Input() statesIssued: any[] = [];
    @Input() appInfo: ApplicationBusinessInfo;
    @Input() owner: ApplicationSoleOwnerItem = new ApplicationSoleOwnerItem(this.formBuilder, this.authService);
    @Output() backClicked = new EventEmitter<void>();
    @Output() continueClicked = new EventEmitter<any>();

    production: boolean = environment.production;
    cities: any[] = [];
    states: any[] = [];
    googleVariant: any;
    counties: any[] = [];
    googleExperience: any;
    businessCities: any[] = [];
    businessStates: any[] = [];
    businessCounties: any[] = [];
    errorTitle = '';
    errorMessageA = '';
    errorMessageB = '';
    errorMessageC = '';
    errorMessageBClass = '';
    errorId = 'OwnPercentageE';
    submitted = false;
    today = new Date();
    minDate = new Date("1900-1-1");
    maxApplicationAmount: number = 0;
    maxAgeDate = new Date((new Date()).setFullYear(new Date().getFullYear() - 18));
    private user = JSON.parse(localStorage.getItem('logged_user'));

    constructor(
        private connectionService: ConnectionService,
        private formBuilder: FormBuilder,
        private authService: AuthService,
        public googleAnalyticsService: GoogleAnalyticsService,
        private route: ActivatedRoute
    ) {
        this.authService.maxApplicationAmount.then(
            (data: number) => {
                this.maxApplicationAmount = data;
            }
        );
    }

    get buttonContinueDisabled() {
        return !this.owner.oForm.creditAuth.value;
    }

    ngOnInit() {
        this.googleExperience = this.route.snapshot.queryParams.google_experience;
        this.googleVariant = this.route.snapshot.queryParams.google_variant;
        this.owner.oForm.sameAsBusiness.setValue('true');
        this.owner.oForm.creditAuth.setValue(false);
        this.owner.oForm.creditAuthTwo.setValue(false);

        this.avoidWhitespace();
    }

    onZipCodeKeyUp(owner: any) {
        let zipcode = "";
        if (owner.zipCode.value) {
            zipcode = owner.zipCode.value;
        } else {
            zipcode = '0';
        }

        return new Promise((resolve, reject) => {
            this.getZipCodeData(zipcode).then(
                (data: any) => {
                    if (data.object) {
                        this.states = this.statesIssued;
                        this.cities = data.object.city;
                        this.counties = data.object.county;
                        owner.state.setValue(data.object.state);
                        owner.city.setValue(data.object.city[0]);
                        owner.county.setValue(data.object.county[0]);
                        resolve(data);
                    } else {
                        this.cities = [];
                        this.states = [];
                        this.counties = [];
                        owner.city.setValue('');
                        owner.county.setValue('');
                        reject();
                    }
                },
                (error: any) => {
                    this.cities = [];
                    this.states = [];
                    this.counties = [];
                    owner.city.setValue('');
                    owner.state.setValue('');
                    owner.county.setValue('');
                    reject();
                }
            );
        });
    }

    onZipCodeKeyUpHandler(owner: any) {
        this.onZipCodeKeyUp(owner).then(
            () => { void (0); },
            () => { void (0); }
        );
    }

    onBusinessZipCodeKeyUp(owner: any) {
        let zipcode = "";
        if (owner.businessZip.value) {
            zipcode = owner.businessZip.value;
        } else {
            zipcode = '0';
        }

        return new Promise((resolve, reject) => {
            this.getZipCodeData(zipcode).then(
                (data: any) => {
                    if (data.object) {
                        this.businessCities = data.object.city;
                        this.businessStates = this.statesIssued;
                        this.businessCounties = data.object.county;
                        owner.businessState.setValue(data.object.state);
                        owner.businessCity.setValue(data.object.city[0]);
                        owner.businessCounty.setValue(data.object.county[0]);
                        resolve(data);
                    } else {
                        this.businessCities = [];
                        this.businessStates = [];
                        this.businessCounties = [];
                        owner.businessCity.setValue('');
                        owner.businessCounty.setValue('');
                        reject();
                    }
                },
                (error: any) => {
                    this.businessCities = [];
                    this.businessStates = [];
                    this.businessCounties = [];
                    owner.businessCity.setValue('');
                    owner.businessState.setValue('');
                    owner.businessCounty.setValue('');
                    reject();
                }
            );
        });
    }

    onBusinessZipCodeKeyUpHandler(owner: any) {
        this.onBusinessZipCodeKeyUp(owner).then(
            () => { void (0); },
            () => { void (0); }
        );
    }

    getZipCodeData(zipCode: string) {
        return new Promise((resolve, reject) => {
            if (this.token) {
                this.connectionService.getRequestWithToken(`${environment.gateway}applicationNl/zipData/${zipCode}`, 'application/json', this.token).subscribe(
                    (data: any) => {
                        resolve(data);
                    },
                    (error: any) => {
                        reject(error);
                    }
                );
            } else {
                this.connectionService.getRequest(`${environment.gateway}application/zipData/${zipCode}`, 'application/json').subscribe(
                    (data: any) => {
                        resolve(data);
                    },
                    (error: any) => {
                        reject(error);
                    }
                );
            }
        });
    }

    showVerifyInformationModal() {
        this.submitted = true;

        this.owner.oForm.authorize.setValue('true');
        this.owner.oForm.businessType.setValue('SoleProprietorship');
        this.owner.oForm.ownershipPercentage.setValue(100);

        if (this.owner.oForm.sameAsBusiness.value == 'true' || this.owner.oForm.sameAsBusiness.value === true) {
            this.owner.oForm.businessAddress.setValue(this.owner.oForm.homeAddress.value);
            this.owner.oForm.businessZip.setValue(this.owner.oForm.zipCode.value);
            this.owner.oForm.businessCity.setValue(this.owner.oForm.city.value);
            this.owner.oForm.businessState.setValue(this.owner.oForm.state.value);
            this.owner.oForm.businessCounty.setValue(this.owner.oForm.county.value);
        }

        if (this.owner.form.invalid) {
            return;
        }

        $('#verifyInformationModal').modal();
    }

    onContinueClick(captcha) {
        this.submitted = true;

        this.owner.oForm.authorize.setValue('true');
        this.owner.oForm.businessType.setValue('SoleProprietorship');
        this.owner.oForm.ownershipPercentage.setValue(100);

        if (this.owner.oForm.sameAsBusiness.value == 'true' || this.owner.oForm.sameAsBusiness.value === true) {
            this.owner.oForm.businessAddress.setValue(this.owner.oForm.homeAddress.value);
            this.owner.oForm.businessZip.setValue(this.owner.oForm.zipCode.value);
            this.owner.oForm.businessCity.setValue(this.owner.oForm.city.value);
            this.owner.oForm.businessState.setValue(this.owner.oForm.state.value);
            this.owner.oForm.businessCounty.setValue(this.owner.oForm.county.value);
        }

        if (this.owner.form.invalid) {
            return;
        }

        let customDimensions = {};
        customDimensions[environment.GA_DIMENSIONS.REFERRAL_PAGE] = this.referralPage;
        customDimensions[environment.GA_DIMENSIONS.GOOGLE_EXPERIENCE] = this.googleExperience ? this.googleExperience : undefined;
        customDimensions[environment.GA_DIMENSIONS.GOOGLE_VARIANT] = this.googleVariant ? this.googleVariant : undefined;
        this.googleAnalyticsService.trackEvent('application', 'sole-owner-information-completed', this.token ? 'application-token' : 'application', 1, this.token ? customDimensions : null);

        this.continueClicked.emit({ owner: this.owner, captcha: captcha });
    }

    onBackClick() {
        let customDimensions = {};
        customDimensions[environment.GA_DIMENSIONS.REFERRAL_PAGE] = this.referralPage;
        customDimensions[environment.GA_DIMENSIONS.GOOGLE_EXPERIENCE] = this.googleExperience ? this.googleExperience : undefined;
        customDimensions[environment.GA_DIMENSIONS.GOOGLE_VARIANT] = this.googleVariant ? this.googleVariant : undefined;
        this.googleAnalyticsService.trackEvent('application', 'sole-owner-back-to-business-information', this.token ? 'application-token' : 'application', 1, this.token ? customDimensions : null);
        this.backClicked.emit();
    }

    onCompleteInformationClick(owner: ApplicationSoleOwnerItem) {
        owner.setDefaultData();

        this.onZipCodeKeyUp(owner.form.controls).then(() => {
            owner.setDefaultData();
        });

        this.onBusinessZipCodeKeyUp(owner.form.controls).then(() => {
            owner.setDefaultData();
        });
        this.owner.form.controls.authorize.setValue('true');
    }

    onSetSameBusiness() {
        this.owner.oForm.businessCity.setValue(this.owner.oForm.city.value);
        this.owner.oForm.businessState.setValue(this.owner.oForm.state.value);
        this.owner.oForm.businessZip.setValue(this.owner.oForm.zipCode.value);
        this.owner.oForm.businessCounty.setValue(this.owner.oForm.county.value);
        this.owner.oForm.businessAddress.setValue(this.owner.oForm.homeAddress.value);
        this.onBusinessZipCodeKeyUp(this.owner.oForm).then(
            () => { void (0); },
            () => { void (0); }
        );
    }

    private avoidWhitespace() {
        this.owner.form.controls.firstName.valueChanges.pipe(distinctUntilChanged()).subscribe(res => {
            this.owner.form.controls.firstName.setValue((res).trimStart());
        });
        this.owner.form.controls.lastName.valueChanges.pipe(distinctUntilChanged()).subscribe(res => {
            this.owner.form.controls.lastName.setValue((res).trimStart());
        });
        this.owner.form.controls.zipCode.valueChanges.pipe(distinctUntilChanged()).subscribe(res => {
            this.owner.form.controls.zipCode.setValue((res).trimStart());
        });
        this.owner.form.controls.homeAddress.valueChanges.pipe(distinctUntilChanged()).subscribe(res => {
            this.owner.form.controls.homeAddress.setValue((res).trimStart());
        });
    }
}
